import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Grup User", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "pr-4 font-semibold" }
const _hoisted_6 = { class: "pr-4 font-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Paginator = _resolveComponent("Paginator")
  const _component_Card = _resolveComponent("Card")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Card, null, _createSlots({
      title: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.route.meta.permission.write)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Tambah Grup",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.redirectAdd())),
                  icon: "pi pi-plus",
                  class: "font-semibold p-button-sm btn-primary"
                }))
              : _createCommentVNode("", true)
          ]),
          (_ctx.route.meta.permission.read)
            ? (_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode(_component_InputIconRightGrey, {
                  placeholder: "Cari minimal 3 karakter...",
                  modelValue: _ctx.inputSearch,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputSearch = $event)),
                  canClick: true,
                  onSubmitInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onSearch())),
                  onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.onSearch()), ["enter"])),
                  type: _ctx.$enumBase.input.text,
                  icon: _ctx.$icon.svg.searchEva
                }, null, 8, ["modelValue", "type", "icon"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (_ctx.route.meta.permission.read)
        ? {
            name: "content",
            fn: _withCtx(() => [
              _createVNode(_component_DataTable, {
                id: "table-group-user",
                value: _ctx.data,
                class: "expanded-table table-og",
                responsiveLayout: "scroll",
                paginator: false,
                rows: _ctx.filters.pageSize
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Column, { header: "Nama Group" }, {
                    body: _withCtx((slotProps) => [
                      _createVNode("p", _hoisted_5, _toDisplayString(slotProps.data.Nama), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, { header: "Deskripsi" }, {
                    body: _withCtx((slotProps) => [
                      _createVNode("p", _hoisted_6, _toDisplayString(slotProps.data.Keterangan), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Action",
                    style: {"width":"10%","text-align":"center"}
                  }, {
                    body: _withCtx((slotProps) => [
                      (_ctx.route.meta.permission.update)
                        ? (_openBlock(), _createBlock("i", {
                            key: 0,
                            class: "pi pi-ellipsis-h text-base cursor-pointer text-black",
                            "aria:haspopup": "true",
                            onClick: ($event: any) => (_ctx.showDropDown($event, slotProps.data.Id))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "rows"])
            ])
          }
        : undefined,
      (_ctx.route.meta.permission.read)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              (_ctx.filters.totalRecords > 0)
                ? (_openBlock(), _createBlock(_component_Paginator, {
                    key: 0,
                    rows: _ctx.filters.pageSize,
                    totalRecords: _ctx.filters.totalRecords,
                    onPage: _ctx.onPage
                  }, null, 8, ["rows", "totalRecords", "onPage"]))
                : _createCommentVNode("", true)
            ])
          }
        : undefined
    ]), 1024),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          edit: _ctx.route.meta.permission.update,
          onEdit: _cache[5] || (_cache[5] = ($event: any) => (_ctx.redirectEdit(_ctx.currentId))),
          editPermission: _ctx.route.meta.permission.update,
          onEditPermission: _cache[6] || (_cache[6] = ($event: any) => (_ctx.redirectEditPermission(_ctx.currentId)))
        }, null, 8, ["edit", "editPermission"])
      ]),
      _: 1
    }, 512)
  ]))
}